export default __webpack_public_path__ + "static/media/klimator-logo-min.6ffc68db.svg";